export default __webpack_public_path__ + "0daa6ab9bbf363b6f8064fdf1763045f.woff2";